import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Fade,
  Chip,
  Divider,
  useTheme,
  alpha,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  Home as HomeIcon,
  Refresh as RefreshIcon,
  ArrowForward as ArrowForwardIcon,
  FileDownload as ExportIcon,
  Delete as DeleteIcon,
  MoreVert as MoreIcon,
  ContactPage as ContactIcon,
     ArrowBack as ArrowBackIcon,
  Place as PlaceIcon
} from "@mui/icons-material";
import styled from 'styled-components';

// Styled Components
const StyledContainer = styled(Box)`
  background: linear-gradient(135deg, #f8faff 0%, #e3f2fd 100%);
  min-height: 100vh;
  padding: 24px;
`;

const HeaderWrapper = styled(Box)`
  margin-bottom: 24px;
  padding: 0 16px; 

`;

const HeaderCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(13, 110, 253, 0.12) !important;
  border: 1px solid rgba(13, 110, 253, 0.1);
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  }
`;

const FormCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(13, 110, 253, 0.1) !important;
  border: 1px solid rgba(13, 110, 253, 0.08);
  margin-bottom: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(13, 110, 253, 0.15) !important;
  }
`;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(13, 110, 253, 0.1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.2);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const ActionButton = styled(Button)`
  border-radius: 12px !important;
  padding: 12px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const ExportButton = styled(Button)`
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3) !important;
  }
`;

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(20px);
    border-radius: 16px !important;
    border: 1px solid rgba(13, 110, 253, 0.1);
    box-shadow: 0 8px 32px rgba(13, 110, 253, 0.15) !important;
    min-width: 180px;
    margin-top: 8px;
  }
  
  .MuiMenuItem-root {
    border-radius: 8px !important;
    margin: 4px 8px !important;
    transition: all 0.2s ease !important;
    
    &:hover {
      background: rgba(13, 110, 253, 0.08) !important;
      transform: translateX(4px);
    }
  }
`;

function SiteDetail({ onSwitchToContact, setAnswer, answer = {} }) {
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const changeAraId = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      araId: e.target.value,
    }));
  };

  const changeCompany = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      company: e.target.value,
    }));
  };

  const changeAddress = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      address: e.target.value,
    }));
  };

  const changeAddress2 = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      address2: e.target.value,
    }));
  };

  const changeState = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      state: e.target.value,
    }));
  };

  const changeCity = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      city: e.target.value,
    }));
  };

  const changeZipcode = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      zipcode: e.target.value,
    }));
  };

  const changeRecheckcycle = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      recheckcycle: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSwitchToContact();
  };

  return (
    <StyledContainer>
      {/* Header Section */}
      <HeaderWrapper>
                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                   <IconButton 
                     onClick={onSwitchToContact}
                     sx={{ mr: 1 }} 
                   >
                     <ArrowBackIcon />
                   </IconButton>
                   <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                     Add Site
                   </Typography>
                 </Box>
               
                 <Box>
                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                     <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
                       Step 1 of 2
                     </Typography>
                     <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                       Site Details
                     </Typography>
                   </Box>
                   <Box sx={{ flexGrow: 1, height: '8px', background: alpha('#0d6efd', 0.2), borderRadius: '4px', overflow: 'hidden' }}>
                     <Box sx={{ width: '50%', height: '100%', background: '#0d6efd', borderRadius: '4px' }} /> 
                   </Box>
                 </Box>
               </HeaderWrapper>

      <form onSubmit={handleSubmit}>
        {/* Site Information */}
        <Fade in timeout={500}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <BusinessIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                    Site Information
                  </Typography>
                </Box>
                
                <IconButton
                  sx={{
                    color: '#f44336',
                    background: alpha('#f44336', 0.1),
                    '&:hover': {
                      background: alpha('#f44336', 0.2),
                      transform: 'scale(1.05)'
                    }
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="ARA ID"
                    value={answer.araId || ''}
                    onChange={changeAraId}
                    InputProps={{
                      startAdornment: (
                        <BusinessIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Company"
                    value={answer.company || ''}
                    onChange={changeCompany}
                    InputProps={{
                      startAdornment: (
                        <BusinessIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    required
                  />
                </Grid>
              </Grid>
            </CardContent>
          </FormCard>
        </Fade>

        {/* Address Information */}
        <Fade in timeout={700}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <PlaceIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                  Address Information
                </Typography>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Address"
                    value={answer.address || ''}
                    onChange={changeAddress}
                    InputProps={{
                      startAdornment: (
                        <LocationIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Address 2"
                    value={answer.address2 || ''}
                    onChange={changeAddress2}
                    InputProps={{
                      startAdornment: (
                        <HomeIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    placeholder="Apartment, suite, etc. (optional)"
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <StyledTextField
                    fullWidth
                    label="City"
                    value={answer.city || ''}
                    onChange={changeCity}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <StyledTextField
                    fullWidth
                    label="State"
                    value={answer.state || ''}
                    onChange={changeState}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <StyledTextField
                    fullWidth
                    label="ZIP Code"
                    value={answer.zipcode || ''}
                    onChange={changeZipcode}
                    required
                  />
                </Grid>
              </Grid>
            </CardContent>
          </FormCard>
        </Fade>

        {/* Site Configuration */}
        <Fade in timeout={900}>
          <FormCard>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <RefreshIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                  Site Configuration
                </Typography>
                <Chip 
                  label="Optional"
                  size="small"
                  sx={{ 
                    ml: 2,
                    background: alpha('#64748b', 0.1),
                    color: '#64748b',
                    fontWeight: 500
                  }}
                />
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Recheck Cycle"
                    value={answer.recheckcycle || ''}
                    onChange={changeRecheckcycle}
                    InputProps={{
                      startAdornment: (
                        <RefreshIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    placeholder="e.g., 30 days"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </FormCard>
        </Fade>

        {/* Action Button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <ActionButton
            type="submit"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0a58ca 0%, #084298 100%)',
                boxShadow: '0 8px 25px rgba(13, 110, 253, 0.3)'
              }
            }}
          >
            Next
          </ActionButton>
        </Box>
      </form>

      {/* Context Menu */}
      <StyledMenu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <ExportIcon sx={{ color: '#4caf50' }} />
          </ListItemIcon>
          <ListItemText primary="Export Data" />
        </MenuItem>
        
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <DeleteIcon sx={{ color: '#f44336' }} />
          </ListItemIcon>
          <ListItemText primary="Delete Site" />
        </MenuItem>
      </StyledMenu>
    </StyledContainer>
  );
}

export default SiteDetail;